enum OrderFinancingTypeEnum
{
    INSTALLMENT = "INSTALLMENT",
    OPERATING_LEASE = "OPERATING_LEASE",
    CONSUMER_LOAN = "CONSUMER_LOAN",
}

export default OrderFinancingTypeEnum;
